import type { Product } from '@easyhelp/shared';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export interface ProductListProps {
  products: Product[];
  selectedId: string | null;
  onSelect: (product: Product) => void;
  onEdit: (product: Product) => void;
}

/** Elenco dei prodotti con prefisso (lucchetto se bloccato dai ticket) e consumer attivi; uno è selezionato. */
export function ProductList({ products, selectedId, onSelect, onEdit }: ProductListProps) {
  return (
    <Paper variant="outlined" sx={{ flex: '0 0 auto', width: { md: 320 } }}>
      {products.length === 0 ? (
        <Typography color="text.secondary" sx={{ p: 4 }}>
          Nessun prodotto: un prodotto nasce registrando il suo primo consumer in Impostazioni › Consumer.
        </Typography>
      ) : (
        <List disablePadding aria-label="Prodotti">
          {products.map((product) => (
            <ListItem
              key={product.id}
              divider
              disablePadding
              secondaryAction={
                <Tooltip title="Modifica nome e prefisso">
                  <IconButton aria-label={`Modifica il prodotto ${product.name}`} onClick={() => onEdit(product)}>
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
              }
            >
              <ListItemButton
                selected={product.id === selectedId}
                onClick={() => onSelect(product)}
                aria-label={`Configura ${product.name}`}
                aria-current={product.id === selectedId ? 'true' : undefined}
                sx={{ pr: 12 }}
              >
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Typography component="span" fontWeight={500}>
                        {product.name}
                      </Typography>
                      <Chip
                        size="small"
                        variant="outlined"
                        label={product.prefix}
                        icon={product.prefixLocked ? <LockOutlinedIcon aria-label="Prefisso bloccato" /> : undefined}
                        sx={{ fontFamily: (theme) => theme.typography.fontFamilyMonospace }}
                      />
                    </Stack>
                  }
                  secondary={`${product.activeConsumerCount} consumer ${product.activeConsumerCount === 1 ? 'attivo' : 'attivi'}`}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}
